import * as tslib_1 from "tslib";
import { Inject, Injectable } from '@angular/core';
import { FORMLY_CONFIG_TOKEN } from './formly.config';
var FormlyValidationMessages = (function () {
    function FormlyValidationMessages(configs) {
        if (configs === void 0) { configs = []; }
        var _this = this;
        this.messages = {};
        configs.map(function (config) {
            if (config.validationMessages) {
                config.validationMessages.map(function (validation) { return _this.addStringMessage(validation.name, validation.message); });
            }
        });
    }
    FormlyValidationMessages.prototype.addStringMessage = function (name, message) {
        this.messages[name] = message;
    };
    FormlyValidationMessages.prototype.getMessages = function () {
        return this.messages;
    };
    FormlyValidationMessages.prototype.getValidatorErrorMessage = function (name) {
        return this.messages[name];
    };
    return FormlyValidationMessages;
}());
FormlyValidationMessages = tslib_1.__decorate([
    Injectable(),
    tslib_1.__param(0, Inject(FORMLY_CONFIG_TOKEN)),
    tslib_1.__metadata("design:paramtypes", [Array])
], FormlyValidationMessages);
export { FormlyValidationMessages };
//# sourceMappingURL=formly.validation-messages.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/services/formly.validation-messages.js
// module id = 326
// module chunks = 3